import { BarChart3, Target, HelpCircle, AlertCircle, TrendingUp } from "lucide-react"

interface QuickActionsProps {
  onAction: (prompt: string) => void
  className?: string
}

interface QuickAction {
  icon: any
  label: string
  prompt: string
  color: string
}

const QUICK_ACTIONS: QuickAction[] = [
  {
    icon: BarChart3,
    label: "Win rate report",
    prompt: "What's our dispute win rate over the last 3 months? Break it down by source.",
    color: "text-blue-500 bg-blue-50",
  },
  {
    icon: Target,
    label: "Prioritize deductions",
    prompt: "What deductions should I work on right now? Show me the highest value ones I can dispute.",
    color: "text-purple-500 bg-purple-50",
  },
  {
    icon: AlertCircle,
    label: "Follow up on disputes",
    prompt: "Are there any disputes that need follow-up? Show me ones that have been waiting the longest.",
    color: "text-amber-500 bg-amber-50",
  },
  {
    icon: TrendingUp,
    label: "Customer deduction rates",
    prompt: "Which customers have the highest deduction rates? Break it down by source and amount.",
    color: "text-green-500 bg-green-50",
  },
  {
    icon: HelpCircle,
    label: "How to fight overpulls",
    prompt: "How would I fight an overpull deduction? What documentation do I need?",
    color: "text-rose-500 bg-rose-50",
  },
]

export function QuickActions({ onAction, className }: QuickActionsProps) {
  return (
    <div class={`w-full max-w-2xl ${className || ""}`}>
      <p class="text-xs font-medium text-gray-500 mb-3 text-center">Try asking</p>
      <div class="flex flex-wrap gap-2 justify-center">
        {QUICK_ACTIONS.map((action: QuickAction) => (
          <button
            key={action.label}
            type="button"
            onClick={() => onAction(action.prompt)}
            class="flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 hover:border-gray-300 transition-colors text-sm text-gray-600"
          >
            <action.icon class={`w-4 h-4 ${action.color.split(" ")[0]}`} />
            <span>{action.label}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
